/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

const API = {
  TRIGGER_SEMANTIC: {
    path: '/organizations/:organizationId/platform/analytics/semantic',
    method: 'POST',
  },
  TRIGGER_NON_SEMANTIC: {
    path: '/organizations/:organizationId/platform/analytics/non-semantic',
    method: 'POST',
  },
};

export default API;
